import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

import HookedSubmit from 'components/Form/HookedSubmit';
import { creditCardValidators } from 'modules/creditCard';
import { useDialogMakePaymentContext } from '../dialogMakePaymentContext';
import SavedPaymentMethods from './SavedPaymentMethods';
import useChosenPaymentMethod from '../useChosenPaymentMethod';

export interface ChooseSavedPaymentMethodProps
	extends Omit<StackProps, 'children'> {
	isSubmitting: boolean;
}

const ChooseSavedPaymentMethod = ({
	isSubmitting,
	sx,
	...rest
}: ChooseSavedPaymentMethodProps) => {
	const { formValues } = useDialogMakePaymentContext();
	const { chosenInstrumentId, requiresCVV } = useChosenPaymentMethod();

	const invalidCVV = Boolean(
		creditCardValidators.cardCode(formValues.cardCode),
	);

	const invalidRequiredCVV = invalidCVV && requiresCVV;

	return (
		<Stack sx={combineSx({ gap: 300 }, sx)} {...rest}>
			<SavedPaymentMethods />

			<HookedSubmit
				size="large"
				color="highlight"
				disabled={!chosenInstrumentId || invalidRequiredCVV}
				loading={isSubmitting}
			>
				Continue
			</HookedSubmit>
		</Stack>
	);
};
export default ChooseSavedPaymentMethod;
